<template>
  <div
    v-bind:style="customStyles"
    :class="[
      'customs-spinner',
      $props.classes,
      { hide: hide }
    ]"
  ></div>
</template>

<script>
export default {
  name: "base-spinner",
  props: {
    /**
     * The spinner size
     */
    size: {
      type: String,
      default: "60"
    },
    position: {
      type: String,
      default: "absolute"
    },
    setSpinnerDefault: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hide: this.setSpinnerDefault
    };
  },
  computed: {
    /**
     * Adds custom styles to the spinner
     * @public
     */
    customStyles() {
      return {
        height: this.size + "px",
        width: this.size + "px",
        position: this.position
      };
    }
  },
  methods: {
    hideSpinner(hide) {
      this.$eventBus.$emit("disable-next-back-buttons", !hide);
      this.hide = hide;
    }
  },
  created() {
    this.$eventBus.$on("hide-customs-spinner", this.hideSpinner);
  }
};
</script>
